// extracted by mini-css-extract-plugin
export default {"seeCCXDetailsLink":"MetricsCard_seeCCXDetailsLink__eq04N"};